import { examAssignmentConstants } from '../actions/examAssignment.actions';

const initialState = {
  assignments: [],
  studentExams: [],
  examStudents: [],
  loading: false,
  error: null,
};

export function examAssignments(state = initialState, action: any) {
  switch (action.type) {
    case examAssignmentConstants.ASSIGN_EXAM_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case examAssignmentConstants.ASSIGN_EXAM_SUCCESS:
      return {
        ...state,
        assignments: action.payload,
        loading: false,
      };
    case examAssignmentConstants.ASSIGN_EXAM_FAILURE:
      return {
        ...state,
        error: action.payload,
        loading: false,
      };

    case examAssignmentConstants.GET_STUDENT_EXAMS_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case examAssignmentConstants.GET_STUDENT_EXAMS_SUCCESS:
      console.log('GET_STUDENT_EXAMS_SUCCESS:', action.payload);
      return {
        ...state,
        studentExams: action.payload.data || action.payload,
        loading: false,
      };
    case examAssignmentConstants.GET_STUDENT_EXAMS_FAILURE:
      return {
        ...state,
        error: action.payload,
        loading: false,
      };

    case examAssignmentConstants.GET_EXAM_STUDENTS_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case examAssignmentConstants.GET_EXAM_STUDENTS_SUCCESS:
      return {
        ...state,
        examStudents: action.payload,
        loading: false,
      };
    case examAssignmentConstants.GET_EXAM_STUDENTS_FAILURE:
      return {
        ...state,
        error: action.payload,
        loading: false,
      };

    case examAssignmentConstants.UPDATE_STATUS_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case examAssignmentConstants.UPDATE_STATUS_SUCCESS:
      return {
        ...state,
        loading: false,
      };
    case examAssignmentConstants.UPDATE_STATUS_FAILURE:
      return {
        ...state,
        error: action.payload,
        loading: false,
      };

    case examAssignmentConstants.DELETE_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case examAssignmentConstants.DELETE_SUCCESS:
      return {
        ...state,
        loading: false,
      };
    case examAssignmentConstants.DELETE_FAILURE:
      return {
        ...state,
        error: action.payload,
        loading: false,
      };

    default:
      return state;
  }
}
